<template>
  <div class="boolean-control">
    <label class="control-label font-weight-bold">{{ data.name }}</label>
    <div class="password-input-wrapper" :class="{ 'is-password': isPasswordType }">
      <input
        :type="inputType"
        v-model="value"
        class="form-control"
        :class="{ 'field-error': this.$v.value.$error, 'has-toggle': isPasswordType }"
        autocomplete="off"
        v-on:keydown="onlyNumbers"
      />
      <button
        v-if="isPasswordType"
        type="button"
        class="password-toggle-btn"
        :title="showPassword ? 'Hide password' : 'Show password'"
        @mousedown.prevent="showPasswordValue"
        @mouseup.prevent="hidePasswordValue"
        @mouseleave="hidePasswordValue"
        @touchstart.prevent="showPasswordValue"
        @touchend.prevent="hidePasswordValue"
        @touchcancel.prevent="hidePasswordValue"
        @keydown.space.prevent="showPasswordValue"
        @keyup.space.prevent="hidePasswordValue"
        @keydown.enter.prevent="showPasswordValue"
        @keyup.enter.prevent="hidePasswordValue"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 5C6 5 2 12 2 12s4 7 10 7 10-7 10-7-4-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
          <circle cx="12" cy="12" r="2.3" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { only_numbers } from "@/helpers/common";
import requiredIf from "vuelidate/lib/validators/requiredIf";

export default {
  name: "InputControl",
  props: ["data", "size"],
  data() {
    return {
      value: "",
      controlData: this.data ? this.data : {},
      showPassword: false,
    };
  },
  computed: {
    isPasswordType() {
      return this.data?.type === "password";
    },
    inputType() {
      if (!this.isPasswordType) {
        return "text";
      }

      return this.showPassword ? "text" : "password";
    },
  },
  methods: {
    onlyNumbers(event) {
      if (this.data.type === "integer") {
        return only_numbers(event);
      }

      return true;
    },
    showPasswordValue() {
      this.showPassword = true;
    },
    hidePasswordValue() {
      this.showPassword = false;
    },
    validate() {
      this.$v.value.$touch();
      return !this.$v.value.$invalid;
    },
  },
  mounted() {
    this.$set(this, "value", this.data.value);
    this.$set(this.controlData, "validate", this.validate);
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.controlData = newVal;
      },
      deep: true,
      immediate: true,
    },
    value: function (newVal) {
      this.$emit("onChange", newVal);
    },
  },
  validations() {
    return {
      value: {
        required: requiredIf(function (val) {
          return this.data.is_required === 1;
        }),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.password-input-wrapper {
  position: relative;

  &.is-password {
    .form-control.has-toggle {
      padding-right: 44px;
    }
  }
}

.password-toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  padding: 0;
  width: 22px;
  height: 22px;
  color: #7a7a7a;
  cursor: pointer;

  &:hover,
  &:focus {
    color: #3a3a3a;
    outline: none;
  }

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
}
</style>
